// extracted by mini-css-extract-plugin
export default {"recover":"recovery_recover__OL9iR","title":"recovery_title__e6SQ6","content":"recovery_content__oRCo6","logo":"recovery_logo__n7Y4P"};